import { Spin, Tabs } from "antd";
import React, { FunctionComponent } from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { Routes } from "src/common/Routes";
import BackTextComponent from "../../../components/BackTextComponent";
import { ContainerBox } from "../../../components/container-box";
import { PageTitle } from "../../../components/page-title";
import { useInformationAssetDetailController } from "./controller";
import "./index.scss";
import { ApiErrorContent } from "src/components/ErrorOnApiFailed";
import SystemResourcesTable from "./system-resources-table";
import { AccessDetails } from "./access-detail-tab";

export type InformationAssetDetailProps = RouteComponentProps<{
  assetId: string;
  activeTab: string;
}>;

export const InformationAssetDetail: FunctionComponent<InformationAssetDetailProps> = (
  props: InformationAssetDetailProps
) => {
  const controller = useInformationAssetDetailController(props);
  const renderSystemResourceTypeTab = () => {
    return (
      <>
        {controller.systemResourceTypeTabs.map((systemResourceTypeTab) => {
          return (
            <Tabs.TabPane
              tab={systemResourceTypeTab.selectedResourceType}
              key={systemResourceTypeTab.id}
              closable={true}
            >
              <SystemResourcesTable
                assetId={props.match.params.assetId}
                selectedSystem={systemResourceTypeTab.selectedSystem}
                selectedSystemResourceType={systemResourceTypeTab.selectedResourceType}
                group={systemResourceTypeTab.group}
              />
            </Tabs.TabPane>
          );
        })}
      </>
    );
  };

  function renderTabs() {
    return (
      <div className={"tab-container"}>
        <Tabs
          type="editable-card"
          defaultActiveKey={"accessDetails"}
          activeKey={controller.getActiveTab()}
          onChange={controller.setActiveTab}
          onEdit={controller.tabOnEdit}
          hideAdd
        >
          <Tabs.TabPane tab={"Access details"} key={"accessDetails"} closable={false}>
            <AccessDetails resourceId={props.match.params.assetId} />
          </Tabs.TabPane>
          {renderSystemResourceTypeTab()}
        </Tabs>
      </div>
    );
  }

  const renderInformationAsset = () => {
    const informationAsset = controller.getInformationAsset();
    if (informationAsset) {
      return (
        <>
          <div className={"asset-information"}>
            <PageTitle title={informationAsset.name.toString()} />
            {renderTabs()}
          </div>
        </>
      );
    }
    return null;
  };

  const renderContent = () => {
    if (controller.shouldRenderProgress()) {
      return <Spin />;
    }
    if (controller.isErrorLoadingApis) {
      return <ApiErrorContent />;
    }
    if (controller.shouldRenderAssetDetail()) {
      return renderInformationAsset();
    }
    if (controller.isAssetIdInValid) {
      return <Redirect to={Routes.NotFound.path} />;
    }
    return null;
  };
  return (
    <>
      <div className={"InformationAssetDetail"}>
        <ContainerBox>
          <BackTextComponent
            backText={"Information Assets"}
            clickFunctionality={controller.backButtonClickFunctionality}
          />
          {renderContent()}
        </ContainerBox>
      </div>
    </>
  );
};
